import React from 'react';
import { Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { colors } from '@mui/material';
import { useTranslation } from 'utils/translation';
import config from 'config/app';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 10000,
  },
  content: {
    backgroundColor: colors.orange[600],
    color: '#fff',
    padding: theme.spacing(0.25, 3),
    textTransform: 'uppercase',
    textAlign: 'center',
    borderRadius: '0 0 6px 6px',
  },
}));

const TestWarning = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  const isTestEnv = config.isTestEnv;

  if (!isTestEnv) {
    return null;
  }

  return (
    <div className={classes.root}>
      <div className={classes.content}>
        <Typography variant="caption" color="inherit">
          {t('Test Data')}
        </Typography>
      </div>
    </div>
  );
};

export default TestWarning;
